// extracted by mini-css-extract-plugin
export default {"pie-chart-wrapper":"PiChart_pie-chart-wrapper__msKJV","title":"PiChart_title__1un1-"};